import React from "react";

const SelectBox = ({ options, onChange, value, name,className, placeholder }) => {
    return (

        <select
            value={value}
            onChange={onChange}
            name={name}
            className={`border-[1px] w-full h-[49px] mt-0 transition bg-white ease-in-out delay-150 border-[#ccc] truncate leading-[19.07px] text-gray-600 text-lg py-[8px] px-2 lg:pl-3 placeholder:text-base  rounded-md  focus:outline-none focus:border-blue-300 ${className}`}
            required
        >
            <option value="" selected disabled>
                {/* {t("usedCars.select.transmission")} */}
                {placeholder}
            </option>
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default SelectBox;